export default {
  mock: {
    config: {},
    headers: {},
    status: 200,
    statusText: '',
    data: {
      serviceName: "アイラ地域サポート",
      serviceRssSettings: [
        {
          serviceRssId: 3,
          serviceRssUuid: "servicerss003",
          rssName: "地域のお知らせ",
          rssURL: "https://xxxxx.xxxxx.xxx"
        },
        {
          serviceRssId: 2,
          serviceRssUuid: "servicerss002",
          rssName: "地域の広報",
          rssURL: "https://xxxxx.xxxxx.xxx"
        },
        {
          serviceRssId: 1,
          serviceRssUuid: "servicerss001",
          rssName: "地域の医療情報",
          rssURL: "https://xxxxx.xxxxx.xxx"
        }
      ]
    }
  }
}